export default "__VITE_ASSET__Cug3QL72__"